import { render } from "./psychologicalCounseling.vue?vue&type=template&id=357d2a88&scoped=true"
import script from "./psychologicalCounseling.vue?vue&type=script&lang=js"
export * from "./psychologicalCounseling.vue?vue&type=script&lang=js"

import "./psychologicalCounseling.vue?vue&type=style&index=0&id=357d2a88&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357d2a88"]])

export default __exports__